import React from 'react';

import {GridList, GridListTile, GridListTileBar} from 'material-ui/GridList';
import Subheader from 'material-ui/List/ListSubheader';
import IconButton from 'material-ui/IconButton';
import DeleteIcon from 'material-ui-icons/Delete';

import axios from 'axios';

import Dropzone from 'react-dropzone';

class Files extends React.Component {
	
	onDrop = (acceptedFiles) => {
		var data = new FormData();
		data.append('uploadedFile', acceptedFiles[0]);
		
		axios.post('/files/upload', data)
		.then((res) => {
			console.log('success upload', res.data);
			
			let files = this.props.files;
			if (!files) {
				files = [];
			}
			files.push({file: res.data});
			
			this.props.onChange(files);
		})
		.catch(function (err) {
			console.error(err);
		});
	}

	deleteFile = (fileId) => () => {
		// remove entry where fileRelation.file.id is ID given
		const files = this.props.files;
		let newFiles = [];
		for (let i in files) {
			if (fileId != files[i].file.id) {
				newFiles.push(files[i]);
			}
		};

		this.props.onChange(newFiles);
	}

	render() {
		return (<div>
			 <Dropzone
				onDrop={this.onDrop}
				accept="image/*"
			/>
			<br /><br />
			{!this.props.files ? '' : 
				<GridList cols={4} cellHeight={140} className="gl">
					{this.props.files.map(function (fileRelation) {
						const file = fileRelation.file;
						return (<GridListTile key={file.id}>
		                    <img src={file.url} alt={file.title} />
		                    <GridListTileBar
		                        title=""
		                        subtitle={
		                            <span>{file.title}</span>
		                        }
		                        actionIcon={
		                            <IconButton onClick={this.deleteFile(file.id)}>
		                                <DeleteIcon color="contrast"/>
		                            </IconButton>
		                        }
		                    />
		                </GridListTile>);
					}, this)}
	            </GridList>
	        }
		</div>);
	}
}

export default Files;




// WEBPACK FOOTER //
// ./app/used/Files.js